import { Component, OnInit, ViewChild } from '@angular/core';
import { CompanyService }  from '../../_services/admin/company.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { LoadingService } from '../../_services/loading.service';
import { NotificationService } from '../../_services/notification.service';
import { DatePipe } from '@angular/common';
import { DialogService } from 'src/app/_services/dialog.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {

  displayedColumns: string[] = ['ID', 'CompanyName', 'CompanyHeading', 'CompanyType', 'Phone', 
  'Mobile', 'Email', 'WebsiteUrl', 'CreatedAt', 'UserId', 'Actions'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;


  constructor(private titleService: Title,
    public companyService: CompanyService,
    private dialog: MatDialog,
    private loading : LoadingService,
    private notificationService: NotificationService,
    public datePipe: DatePipe,
    private dialogService: DialogService,) { }

  ngOnInit() {
    this.titleService.setTitle('Company');
    this.getCompany();
  }

  getCompany() {
    var result = this.companyService.get_companies().subscribe(data=> {
      //console.log(data);
      this.dataSource = new MatTableDataSource<any>(data['dataList']);
      this.dataSource.paginator = this.paginator;
      // this.loading.spin$.next(false);
    });
  }

  applyFilter(){
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }
  onSearchClear(){
    this.searchKey = "";
    this.applyFilter();
  }

  onCreate() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "60%";
    matDialogConfig.position = { top: '100px' }
    //this.dialog.open(CreateCompanyDialog, matDialogConfig);

    this.dialog.open(CreateCompanyDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.getCompany();
    });
  }

  onEdit(row){
    //console.log(row);
    this.companyService.populateForm(row);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "60%";
    matDialogConfig.position = { top: '100px' }
    //this.dialog.open(CreateCompanyDialog, matDialogConfig);

    this.dialog.open(CreateCompanyDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.getCompany();
    });
  }

  onDelete(rowid){
    this.dialogService.openConfirmDialog('Are you sure to delete this record ?')
      .afterClosed().subscribe(res =>{
        if(res) {
          this.loading.spin$.next(true);
          this.companyService.delete_company_details(rowid).subscribe(data=>{
            if(JSON.stringify(data['status'])=='true') {
              this.getCompany();             
              this.loading.spin$.next(false);
              this.notificationService.warn(data['message']);
            }
            else {
              this.notificationService.error(JSON.stringify(data['error_message']));
              this.loading.spin$.next(false);
            }
          });
        }
    }); 
  }

  onView(rowData) {
    this.companyService.viewCompanyData = rowData;
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "60%";
    matDialogConfig.position = { top: '100px' }
    //this.dialog.open(ViewCompanyDialog, matDialogConfig);

    this.dialog.open(ViewCompanyDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.getCompany();
    });
  }

}





/* Create Company */

@Component({
  selector: 'create-company-dialog',
  templateUrl: 'create-company-dialog.html',
})
export class CreateCompanyDialog {

  constructor(private dialogRef: MatDialogRef<CompaniesComponent>,
    public companyService: CompanyService,
    private loading : LoadingService,
    private notificationService: NotificationService,) {

   }

   onCompanyAddedFormSubmit(formData: any)
   {
     if (this.companyService.company_form.valid)
     {
      this.loading.spin$.next(true);

      if(!this.companyService.company_form.controls['id'].value)
      {
        // Insert Data
        this.companyService.insert_company_details(formData).subscribe(data=>{
          //console.log(data);
          if (data['status']) 
          {
            this.notificationService.success('Company Created Successfully.');  
            this.companyService.company_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          } 
          else 
          {
            this.notificationService.error('Company could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else
      {
        // Update Data
        console.log('data updated');
        this.companyService.update_company_details(formData).subscribe(data=>{
          //console.log(data);
          if (data['status']) 
          {
            this.notificationService.success('Company data updated Successfully.');  
            this.companyService.company_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          } 
          else 
          {
            this.notificationService.error('Company data could not be updated, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      } 
     }
   }



  onClose(){
    // console.log('Close');
    this.companyService.company_form.reset();
    this.dialogRef.close();
  }

}


/* View Company */

@Component({
  selector: 'view-company-dialog',
  templateUrl: 'view-company-dialog.html',
})
export class ViewCompanyDialog {

  constructor(
    private dialogRef: MatDialogRef<CompaniesComponent>,
    public companyService: CompanyService,
    public datePipe: DatePipe,) {
      //console.log(this.companyService.viewCompanyData);
   }

  onClose(){
    this.dialogRef.close();
    this.companyService.viewCompanyData = null ;
  }

}
